import { createContext } from 'react'
import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'

import RootStore from '../store/root'

type Props = {
  children?: ReactNode
}

export const rootStore = new RootStore()
export const StoresContext = createContext(rootStore)

const StoreProvider = observer(({ children }: Props) => {
  return <StoresContext.Provider value={rootStore}>{children}</StoresContext.Provider>
})

export default StoreProvider
